<template>
  <v-select
    :items="items"
    height="30" 
    dense
    :value="trans('Popularity')"
    outlined
    rounded
    @change="value => sortActivities(value)"
  ></v-select>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      items: [
        Vue.prototype.trans('Popularity'),
        Vue.prototype.trans('Rating'),
        Vue.prototype.trans('Newest'),
        Vue.prototype.trans('Lowest Price'),
        Vue.prototype.trans('Highest Price'),
      ],
    };
  },
  methods: {
    sortActivities(value) {
      this.$parent.$root.sortby = value.toLowerCase();
      Fire.$emit('searching');
    },
  },
};
</script>

<style scoped>
.v-input {
  max-width: 140px !important;
  min-width: 140px !important;
}

::v-deep .v-input__control  .v-input__slot {
    min-height: 32px !important;
    padding:0px 14px;
}

::v-deep .v-input__control  .v-input__append-inner {
  margin-top: 4px !important;
}

::v-deep .v-text-field__details {
  display: none !important;
}

::v-deep .v-select__selection{
  font-size: 14px !important;
}

@media (max-width: 768px) {
  .v-input {
    max-width: 100% !important;
    min-width: auto !important;
    margin: 10px 0;
  }
}
</style>
